import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/icons/logo_black-green-full.png';
var _hoisted_1 = {
  class: "container",
  "data-cy": "login-page"
};
var _hoisted_2 = {
  class: "columns is-vcentered is-centered"
};
var _hoisted_3 = {
  class: "column is-4"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "has-text-centered mb-4"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: "Logo",
  width: "200"
})], -1);

var _hoisted_5 = {
  class: "has-text-centered mb-6"
};
var _hoisted_6 = {
  class: "has-text-grey-light has-text-weight-semibold"
};
var _hoisted_7 = {
  class: "is-flex is-justify-content-space-between is-full-width is-size-6"
};
var _hoisted_8 = {
  class: "el-form-item__label"
};
var _hoisted_9 = {
  class: "is-flex is-justify-content-center mt-6"
};
import { computed, ref, reactive, onMounted } from "vue";
import { useI18n } from "vue-i18n"; // modules

import AuthModule from "@/store/modules/auth";
import UserModule from "@/store/modules/user";
import ModalModule from "@/store/modules/modal";
import POSConfigModule from "@/store/modules/pos-config";
import CashFloatModule from "@/store/modules/cash-float"; // helpers

import { ModalStatus } from "@/constants/modal";
import { pushWithQuery, redirectToLoginPage } from "@/utils/helpers/router.helper";
import { initializeIntercomWithoutCompanyData } from "@/utils/helpers/store";
import { RouteNames } from "@/constants/router";
import { selectUserGroup } from "@/utils/vue-helpers/group";
import * as Sentry from "@sentry/vue";
import DeviceModule from "@/store/modules/device";
import CommonModule from "@/store/modules/common";
import { getLanguage } from "@/utils/helpers/lang";
import { LogService } from "@/services/logging";
import AppModule from "@/store/modules/app";
import { addToUserSwitch } from "@/utils/vue-helpers/cash-float";
import { checkUserSocialSecurityNumber, getSmtzAuth, setSmtzAuth } from "@/utils/helpers/auth";
import { NetworkErrors } from "@/constants/errors/network";
import NotificationService from "@/services/notification.service";
import { closeCustomerDisplay } from "@/utils/vue-helpers/customer-display";
import i18n from "@/lang";
import { syncDeviceLocation } from "@/utils/helpers/device";
import { processAdditionalEvents } from "@/utils/helpers/compliance";
import { EventType } from "@smeetz/compliance-common";
export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup: function setup(__props) {
    // common
    initializeIntercomWithoutCompanyData;
    var form = ref();
    var isShowPass = ref(false);
    var isLoading = ref(false); // const { t } = useI18n();

    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var ruleForm = reactive({
      username: "",
      password: ""
    });
    var rules = reactive({
      username: [{
        required: true,
        message: t("field.email-required"),
        trigger: "blur"
      }, {
        type: "email",
        message: t("field.email-invalid"),
        trigger: ["blur", "change"]
      }],
      password: [{
        required: true,
        message: t("field.password-required"),
        trigger: "change"
      }]
    });
    /**
     * Change input type
     *
     * @returns {void}
     */

    var onClick = function onClick() {
      isShowPass.value = !isShowPass.value;
    };
    /**
     * Get text for password visibility button
     *
     * @returns {string}
     */


    var getButtonText = computed(function () {
      return isShowPass.value ? t("field.hide-password") : t("field.show-password");
    });
    var adminUserWithoutGroup = computed(function () {
      return UserModule.isAdminUserWithoutGroup;
    });

    var submitForm = function submitForm() {
      if (!form.value) return;
      form.value.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var _cashFloat$value, _cashFloat$value2, _posConfig$value, _posConfig$value2, _posConfig$value3, smtzAuthToken, posConfig, cashFloat, selectableGroupIds, isSocialSecurityNumberValid, configExists, groupChanged, logParams;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 61;
                    break;
                  }

                  isLoading.value = true;
                  _context.prev = 2;
                  _context.next = 5;
                  return AuthModule.Login(ruleForm);

                case 5:
                  _context.next = 7;
                  return getSmtzAuth();

                case 7:
                  smtzAuthToken = _context.sent;
                  setSmtzAuth(smtzAuthToken);
                  _context.next = 11;
                  return UserModule.fetchUser();

                case 11:
                  // if there are open sales already, add newly logged in user to userSwitch
                  addToUserSwitch(); // Set the userId and deviceId as extra tags for Syntry

                  Sentry.setTags({
                    userId: UserModule.userId || "",
                    deviceId: DeviceModule.id || "",
                    hardwareUuid: DeviceModule.hardwareInfo && DeviceModule.hardwareInfo.id ? DeviceModule.hardwareInfo.id : ""
                  }); // Fetch countries here and use the current language as parameter
                  // we refetch them everytime the language is changed

                  _context.next = 15;
                  return CommonModule.fetchCountries({
                    lang: getLanguage()
                  });

                case 15:
                  _context.next = 17;
                  return CommonModule.fetchLanguages();

                case 17:
                  _context.next = 19;
                  return CommonModule.fetchUserCountry();

                case 19:
                  _context.next = 26;
                  break;

                case 21:
                  _context.prev = 21;
                  _context.t0 = _context["catch"](2);

                  if (_context.t0.message === NetworkErrors.NoAccessToken || _context.t0.message === NetworkErrors.NoSmtzAuthToken) {
                    // show an error and logout if graphql auth token was not obtained
                    NotificationService.showGeneralResponseError(); // do not sign work out event in this case, since work in hasn't happened yet

                    AuthModule.UserLogOut({
                      signWorkOutEvent: false
                    });
                    redirectToLoginPage();
                  }

                  LogService.info("Login failed ", {
                    error: _context.t0
                  });
                  return _context.abrupt("return");

                case 26:
                  _context.prev = 26;
                  isLoading.value = false;
                  return _context.finish(26);

                case 29:
                  posConfig = computed(function () {
                    return POSConfigModule.selectedConfig;
                  });
                  cashFloat = computed(function () {
                    return CashFloatModule.cashFloat;
                  });
                  selectableGroupIds = computed(function () {
                    return UserModule.selectableUserGroups.map(function (userGroup) {
                      return userGroup.group.id;
                    });
                  }); // we have to make sure that the user has access to the cashfloat group id, if not,
                  // we log him out stating that a sales session is already open with another group id

                  if (!((_cashFloat$value = cashFloat.value) !== null && _cashFloat$value !== void 0 && _cashFloat$value.groupId && !selectableGroupIds.value.includes(cashFloat.value.groupId))) {
                    _context.next = 38;
                    break;
                  }

                  NotificationService.showCustomError(i18n.global.t("cashfloat.different-group-error").replace("XXX", String(cashFloat.value.groupId))); // do not sign work out event in this case, since work in hasn't happened yet

                  AuthModule.UserLogOut({
                    signWorkOutEvent: false
                  });
                  redirectToLoginPage();
                  LogService.info("User has been logged out because he doesn't belong to the group of an already opened cashfloat", {
                    cashFloatGroupId: cashFloat.value.groupId,
                    userGroupIds: selectableGroupIds.value
                  });
                  return _context.abrupt("return");

                case 38:
                  if (!(UserModule.userHasMultipleGroups && !cashFloat.value)) {
                    _context.next = 41;
                    break;
                  }

                  _context.next = 41;
                  return selectUserGroup();

                case 41:
                  // BE only
                  isSocialSecurityNumberValid = checkUserSocialSecurityNumber();

                  if (isSocialSecurityNumberValid) {
                    _context.next = 44;
                    break;
                  }

                  return _context.abrupt("return");

                case 44:
                  // as an extra check for data consistency, if GID is not set, we use the group id stored in the cashfloat
                  if (UserModule.userHasMultipleGroups && (_cashFloat$value2 = cashFloat.value) !== null && _cashFloat$value2 !== void 0 && _cashFloat$value2.groupId && !AppModule.gid) {
                    AppModule.setGID(cashFloat.value.groupId);
                  }

                  _context.next = 47;
                  return syncDeviceLocation();

                case 47:
                  // if POS config not exists in localStorage => open POS config modal
                  configExists = !!(posConfig !== null && posConfig !== void 0 && (_posConfig$value = posConfig.value) !== null && _posConfig$value !== void 0 && _posConfig$value.id);
                  groupChanged = AppModule.gid && posConfig.value && posConfig.value.group !== AppModule.gid;
                  logParams = {
                    posConfigId: posConfig === null || posConfig === void 0 ? void 0 : (_posConfig$value2 = posConfig.value) === null || _posConfig$value2 === void 0 ? void 0 : _posConfig$value2.id,
                    appModuleGid: AppModule.gid,
                    posConfigGroup: (_posConfig$value3 = posConfig.value) === null || _posConfig$value3 === void 0 ? void 0 : _posConfig$value3.group
                  };

                  if (!configExists || groupChanged || configExists && cashFloat.value && UserModule.userId !== cashFloat.value.userId) {
                    LogService.info("User has to reload configs", logParams); // no config is selected OR the user changed the group
                    // let's clear the selected config and show the POSConfiguration modal

                    POSConfigModule.SET_SELECTED_CONFIG(null);
                    ModalModule.setStatus(ModalStatus.PosConfig);
                  } else {
                    // if POS config exists in localStorage => redirect to home page
                    LogService.info("User logged in without reloading config", logParams);
                    pushWithQuery(RouteNames.Booking);
                  } // Lets initialize Intercom after login
                  // await initializeIntercomWithoutCompanyData();
                  // Process WORK IN event


                  _context.prev = 51;
                  _context.next = 54;
                  return processAdditionalEvents(EventType.WORK_IN);

                case 54:
                  _context.next = 59;
                  break;

                case 56:
                  _context.prev = 56;
                  _context.t1 = _context["catch"](51);
                  LogService.info("Error processing WORK IN event", {
                    error: _context.t1
                  });

                case 59:
                  _context.next = 63;
                  break;

                case 61:
                  console.log("error submit!");
                  return _context.abrupt("return", false);

                case 63:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 21, 26, 29], [51, 56]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    var resetForm = function resetForm() {
      if (!form.value) return;
      form.value.resetFields();
    };

    var appVersion = computed(function () {
      return process.env.VUE_APP_VERSION || "";
    }); // TODO: This code requires further testing.
    // onMounted(() => {
    //   // reset growing collections if it wasn't reset alread
    //   if (!isDBReset()) {
    //     resetGrowingCollecitonsFromUI();
    //     return;
    //   }
    //   // let's make sure that in the future, we can reset
    //   setDBReset(false);
    //   // Didn't log here because it causes an error when we reset on the cashfloat close
    //   LogService.info(`DB was already reset, skipping ...`);
    // });

    onMounted(function () {
      // If customer display window is displayed then lets close it
      if (CommonModule.isCustomerScreenOpened) {
        // closing customer display
        closeCustomerDisplay();
      }
    });
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_link = _resolveComponent("el-link");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(appVersion.value), 1)]), _createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: ruleForm,
        rules: rules,
        "label-position": "top",
        "label-width": "120px",
        "hide-required-asterisk": true
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: _ctx.$t('field.email'),
            prop: "username"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: ruleForm.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return ruleForm.username = $event;
                }),
                modelModifiers: {
                  trim: true
                },
                size: "large",
                placeholder: _ctx.$t('field.placeholder-email'),
                "data-cy": "email-input"
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            prop: "password"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_7, [_createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("field.password")), 1), _createVNode(_component_el_link, {
                class: "has-text-weight-semibold",
                type: "primary",
                underline: false,
                onClick: onClick
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(getButtonText.value), 1)];
                }),
                _: 1
              })]), _createVNode(_component_el_input, {
                modelValue: ruleForm.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return ruleForm.password = $event;
                }),
                modelModifiers: {
                  trim: true
                },
                type: isShowPass.value ? 'text' : 'password',
                autocomplete: "off",
                size: "large",
                placeholder: _ctx.$t('field.password-placeholder'),
                onKeypress: _withKeys(submitForm, ["enter"]),
                "data-cy": "password-input"
              }, null, 8, ["modelValue", "type", "placeholder"])];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
            class: "py-5 px-6 mr-4",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return resetForm();
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "py-5 px-6",
            type: "primary",
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return submitForm();
            }),
            loading: _unref(isLoading),
            "data-cy": "submit-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
            }),
            _: 1
          }, 8, ["loading"])])];
        }),
        _: 1
      }, 8, ["model", "rules"])])])]);
    };
  }
});